import * as React from "react"
import styled from "styled-components"
import useTranslation from "../../shared/utils/translation";
import TitleSecondary from "../../shared/components/text/TitleSecondary";
import ParagraphBold from "../../shared/components/text/ParagraphBold";

const Wrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  text-align: center;
  flex-direction: column;
`

const TitleWrapper = styled.div`
  text-align: start;
  margin: 20px 0 10px 0;
`

const StrongWordWrapper = styled.div`
  text-align: start;
  margin: ${p => p.margin ? p.margin : null}
`

const WhyUsText = styled.span`
  text-align: left;
`

const WhyUsSection = () => {
  const t = useTranslation()

  return (
    <Wrapper>
      <WhyUsText>{t("whyus.paragraph1")}</WhyUsText>
      <TitleWrapper>
        <TitleSecondary small={true}>{t("whyus.paragraph2.title")}</TitleSecondary>
      </TitleWrapper>
      <WhyUsText>{t("whyus.paragraph2")}</WhyUsText>
      <StrongWordWrapper margin={"20px 0"}>
        <ParagraphBold small={true}>{t("whyus.strongwords")}</ParagraphBold>
      </StrongWordWrapper>
      <WhyUsText>{t("whyus.paragraph3")}</WhyUsText>
      <StrongWordWrapper margin={"20px 0 0 0"}>
        <ParagraphBold small={true}>{t("whyus.strongwordsquestion")}</ParagraphBold>
      </StrongWordWrapper>
    </Wrapper>
  )
}

export default WhyUsSection
